module.exports = __webpack_public_path__ + "static/img/news.6e05078.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/news.jpg
// module id = zuTN
// module chunks = 1